import {
  Card,
  CardContent,
  CardHeader,
  Fab,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useFieldArray, useFormContext } from "react-hook-form";
import {
  Adresa,
  Drzava,
  DrzavaOperatera,
  ElektronickeAdrese,
  IdentifikatorVrijednost,
  NazivOperateraPlatforme,
  OstaliIdentifikatori,
  OstaliIdentifikatoriDrzavaIzdavatelj,
  OstaliOperateriIdentifikacijskiBroj,
  PrimarniIdentifikator,
  PrimarniIdentifikatorDrzavaIzdavaljetelj,
  PrimarniIdentifikatorVrijednost,
} from "../../../index";
import RemoveIcon from "@mui/icons-material/Remove";

const nazivPolja = "ostaliOperateri";

const Index = () => {
  const { register } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    name: nazivPolja,
  });
  const dodaj = () => {
    append({
      adrese: [
        {
          drzava: {
            oznaka: "",
          },
          mjesto: "",
        },
      ],
      elektronickeAdrese: [],
      identifikatori: [
        {
          vrstaIdentifikatora: { id: undefined },
          drzavaIzdavatelj: { oznaka: "" },
        },
      ],
    });
  };

  const ukloni = (index: number) => {
    remove(index);
  };
  return (
    <div>
      <Card
        variant={"outlined"}
        sx={{ mt: 3, position: "relative" }}
        className={fields.length <= 0 ? "root-p-0" : ""}
      >
        <CardHeader
          title={"Ostali operateri (Other operators)"}
          titleTypographyProps={{ variant: "h6" }}
          action={
            <>
              <Tooltip title={"Dodaj (Add)"}>
                <Fab size={"small"} aria-label="settings" onClick={dodaj}>
                  <AddIcon />
                </Fab>
              </Tooltip>
            </>
          }
        ></CardHeader>
        <CardContent>
          {fields.map((field: any, index) => (
            <Card
              variant={"outlined"}
              sx={{ mt: 3, position: "relative" }}
              key={field.id}
            >
              <CardHeader
                title={`Operater (Operator) ${index + 1}`}
                titleTypographyProps={{ variant: "h6" }}
                action={
                  <Tooltip title={"Ukloni (Remove)"}>
                    <IconButton
                      aria-label="settings"
                      onClick={() => ukloni(index)}
                    >
                      <RemoveIcon />
                    </IconButton>
                  </Tooltip>
                }
              ></CardHeader>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <DrzavaOperatera
                      nazivOdjeljka={`ostaliOperateri[${index}].drzava.oznaka`}
                      nazivOdjeljkaEuSifra={`ostaliOperateri[${index}].drzava.euSifra`}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <NazivOperateraPlatforme
                      nazivOdjeljka={`ostaliOperateri[${index}].naziv`}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <OstaliIdentifikatori
                      nazivPolja={`ostaliOperateri[${index}].identifikatori`}
                      naslov={"Identifikatori (Identifiers)"}
                      oIObavezan={true}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Adresa
                      nazivOdjeljka={`ostaliOperateri[${index}].adrese`}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <ElektronickeAdrese
                      nazivOdjeljka={`ostaliOperateri[${index}].elektronickeAdrese`}
                      naslov={"Elektroničke adrese (Electronic addresses)"}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          ))}
        </CardContent>
      </Card>
    </div>
  );
};

export default Index;
